import { h } from "preact";

import i18n from "../../i18n.js";

import TextField from "../TextField.jsx";
import RadioButtonGroup from "../RadioButtonGroup.jsx";
import Slider from "../Slider.jsx";
import SkillChooser from "../questions/SkillChooser.jsx";
import Combobox from "../questions/Combobox.jsx";
import TextArea from "../TextArea.jsx";

export default function ProjectWizardStep3({ editMode, form, formErrors }) {
  const { fieldsFor } = form;

  return (
    <div>
      <div class="row">
        <div class="col s12 m10 l8 mb-32">
          {!editMode && (
            <h1 class="t-h5 t-h5--margin">
              {i18n.t("component.projects_add.projects_wizard.step3.title")}
              <span class="f-normal ml-8">
                {i18n.t(
                  "component.projects_add.projects_wizard.optional_label"
                )}
              </span>
            </h1>
          )}
          {!editMode && (
            <p class="t-body3 color-shades-charcoal mb-32">
              {i18n.t("component.projects_add.projects_wizard.step3.subtitle")}
            </p>
          )}

          <h3 class="t-subtitle1 t-subtitle1--margin-small">
            {i18n.t("component.projects_add.projects_wizard.step3.about.title")}
            <span class="f-normal ml-8">
              {i18n.t("component.projects_add.projects_wizard.optional_label")}
            </span>
          </h3>
          <p class="t-body3 color-shades-charcoal mb-32">
            {i18n.t(
              "component.projects_add.projects_wizard.step3.about.subtitle"
            )}
          </p>
          <TextArea
            {...fieldsFor("about", {
              serverErrors: formErrors.about,
            })}
            placeholder={i18n.t(
              "component.projects_add.projects_wizard.step3.about.placeholder"
            )}
          />
        </div>

        <div class="col s12 m10 l8 mb-32">
          <h3 class="t-subtitle1 t-subtitle1--margin-small">
            {i18n.t(
              "component.projects_add.projects_wizard.step3.benefits.title"
            )}
            <span class="f-normal ml-8">
              {i18n.t("component.projects_add.projects_wizard.optional_label")}
            </span>
          </h3>
          <p class="t-body3 color-shades-charcoal mb-32">
            {i18n.t(
              "component.projects_add.projects_wizard.step3.benefits.subtitle"
            )}
          </p>
          <TextArea
            {...fieldsFor("benefits", {
              serverErrors: formErrors.benefits,
            })}
            placeholder={i18n.t(
              "component.projects_add.projects_wizard.step3.benefits.placeholder"
            )}
          />
        </div>

        <div class="col s12 m10 l8 mb-32">
          <h3 class="t-subtitle1 t-subtitle1--margin-small">
            {i18n.t(
              "component.projects_add.projects_wizard.step3.qualifications.title"
            )}
            <span class="f-normal ml-8">
              {i18n.t("component.projects_add.projects_wizard.optional_label")}
            </span>
          </h3>
          <p class="t-body3 color-shades-charcoal mb-32">
            {i18n.t(
              "component.projects_add.projects_wizard.step3.qualifications.subtitle"
            )}
          </p>
          <TextArea
            {...fieldsFor("qualifications", {
              serverErrors: formErrors.qualifications,
            })}
            placeholder={i18n.t(
              "component.projects_add.projects_wizard.step3.qualifications.placeholder"
            )}
          />
        </div>

        <div class="col s12 m10 l8 mb-32">
          <h3 class="t-subtitle1 t-subtitle1--margin-small">
            {i18n.t(
              "component.projects_add.projects_wizard.step3.responsibilities.title"
            )}
            <span class="f-normal ml-8">
              {i18n.t("component.projects_add.projects_wizard.optional_label")}
            </span>
          </h3>
          <p class="t-body3 color-shades-charcoal mb-32">
            {i18n.t(
              "component.projects_add.projects_wizard.step3.responsibilities.subtitle"
            )}
          </p>
          <TextArea
            {...fieldsFor("responsibilities", {
              serverErrors: formErrors.responsibilities,
            })}
            placeholder={i18n.t(
              "component.projects_add.projects_wizard.step3.responsibilities.placeholder"
            )}
          />
        </div>
      </div>
    </div>
  );
}
